import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import Cross from "@safecv/assets/Images/cross.png";
import EsInfo from "../../../assets/Images/enhancedsearchinfo.svg";

const customModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    width: "550px",
    bottom: "auto",
    padding: "0px",
    overflow: "hidden",
    borderRadius: "0px",
    transform: "translate(-50%, -50%)",
  },
};

Modal.defaultStyles.overlay.backgroundColor = "rgb(0, 0, 0, 0.5)";

const EnhancedSearchModal = (props) => {

  const { enhancedSearchResult } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sectionArray, setSectionArray] = useState(null);
  const [keywordArray, setKeywordArray] = useState(null);

  const handleModalOpen = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (isModalOpen) {
      let key = [];
      let value = [];
      for (let o in enhancedSearchResult) {
        let o1 = o;
        let a = [];
        key.push(o1);
        let o2 = enhancedSearchResult[o].values;
        for (let i = 0; i < o2.length; i++) {
          a.push(Object.keys(o2[i]));
        }
        value.push(a.flat());
      }
      setSectionArray(key);
      setKeywordArray(value);
    }
  }, [isModalOpen]);

  return (
    <>
      <div className="enchancedsearch-header">
        <div>Key Sections</div>
        <img
          alt=""
          src={EsInfo}
          onClick={handleModalOpen}
          className="enchancedsearch-infoicon"
        />
      </div>
      <Modal
        ariaHideApp={false}
        isOpen={isModalOpen}
        style={customModalStyles}
        onRequestClose={handleModalClose}
        contentLabel="Enhanced Search Modal"
      >
        <div className="modal-enhancedsearch">
          <header>
            <span className="enhancedsearchmodal-header-title">
              Enhanced Search
            </span>
            <span onClick={handleModalClose} className="pointer-css">
              <img src={Cross} alt="Close icon" />
            </span>
          </header>

          <section>
            <div className="enhancedsearch-modal-section-tablecontainer">
              <div className="enhancedsearch-modal-section-tableheader">
                <div className="enhancedsearch-modal-section-tableheader-width">
                  KEY SECTIONS
                </div>
                <div className="enhancedsearch-modal-section-tableheader-width">
                  RELATED KEYWORDS
                </div>
              </div>

              <div className="enhancedsearch-modal-section-tablebody">
                {sectionArray &&
                  sectionArray.map((item, index) => {
                    return (
                      <div
                        className="enhancedsearch-modal-section-tablebody-row"
                        key={index}
                      >
                        <div
                          title={item}
                          className="enhancedsearch-modal-section-tablebody-width-key"
                        >
                          {item}
                        </div>
                        <div
                          title={
                            keywordArray && keywordArray[index]?.join(", ")
                          }
                          className="enhancedsearch-modal-section-tablebody-width-value"
                        >
                          {keywordArray && keywordArray[index]?.join(", ")}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </section>
        </div>
      </Modal>
    </>
  );
};

export default EnhancedSearchModal;